type CenterEntry = {
  key?: unknown;
  variantKeys?: string[];
} & Record<string, unknown>;

type DoctorWithCenters = {
  centers?: CenterEntry[];
} & Record<string, unknown>;

type BookingOptionLike = {
  centerKey?: unknown;
  centerId?: unknown;
  key?: unknown;
};

export function ensureCenterVariantKeys(doctor: DoctorWithCenters, option: BookingOptionLike) {
  if (!doctor || !option) {
    return;
  }

  const centers = Array.isArray(doctor.centers) ? [...doctor.centers] : [];
  if (!centers.length) {
    return;
  }

  const centerKeyRaw = option.centerKey !== undefined && option.centerKey !== null
    ? String(option.centerKey)
    : (option.centerId != null ? String(option.centerId) : null);
  if (!centerKeyRaw) {
    return;
  }

  const centerIndex = centers.findIndex((center) => String(center.key) === centerKeyRaw);
  if (centerIndex === -1) {
    return;
  }

  const center = { ...centers[centerIndex] };
  const variantKeys = Array.isArray(center.variantKeys) ? [...center.variantKeys] : [];
  const normalizedKey = String(option.key);
  if (!variantKeys.includes(normalizedKey)) {
    variantKeys.push(normalizedKey);
  }
  center.variantKeys = variantKeys;
  centers.splice(centerIndex, 1, center);
  doctor.centers = centers;
}
